export default __webpack_public_path__ + "static/nodejs-f31a9f5fd1ea52a965afb4ce9548633d.svg";